module.exports = __webpack_public_path__ + "static/media/24.d6f98574.JPG";